import { Label } from '@/new/components/shadcn/label';
import { Switch } from '@/new/components/shadcn/switch';

interface FilterSwitchProps {
  id: string;
  label: string;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export const FilterSwitch = ({ id, label, checked, onCheckedChange }: FilterSwitchProps) => {
  return (
    <div>
      <div className="flex items-center justify-between">
        <Label htmlFor={id} className="text-sm">
          {label}
        </Label>
        <div className="flex items-center gap-2">
          <Switch className="bg-gray-100" id={id} checked={checked} onCheckedChange={onCheckedChange} />
          <span
            className={`w-12 rounded px-2 py-0.5 text-center text-xs font-medium ${
              checked ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-700'
            }`}
          >
            {checked ? 'TRUE' : 'FALSE'}
          </span>
        </div>
      </div>
    </div>
  );
};
